import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* istanbul ignore file */
import React, { Suspense, useState, useEffect } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import { useAppSelector } from '../../hooks/useAppSelector';
import { PaymentViews } from '../PaymentViews';
import Braintree from '../braintree/Braintree';
import { doBraintreeCallback } from '../braintree/helpers';
import HostedFieldsService from '../../business/processors/braintree/HostedFieldsService';
import { useDispatch } from 'react-redux';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { modeSelector } from '../../redux/AppModeState/AppModeState.selectors';
import { updateDeviceData } from '../../redux/PaymentState/PaymentState.actions';
import { sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import { getString } from '../../constants/Strings';
import { Processors } from '../../constants/AppConstants';
var InitializeBraintree = function InitializeBraintree(props) {
  var optimizelyClient = props.optimizelyClient;
  var config = useAppSelector(configSelector);
  var paymentProcessors = config.paymentProcessors;
  var isBraintreeEnabled = paymentProcessors.indexOf(Processors.BRAINTREE) > -1;
  var mode = useAppSelector(modeSelector);
  var priceSummary = config.priceSummary,
    initialHeadingLevel = config.initialHeadingLevel,
    rioNamespace = config.rioNamespace,
    yiftee = config.yiftee;
  var yifteeBalance = yiftee === null || yiftee === void 0 ? void 0 : yiftee.balance;
  var showHeading = config.showHeading || false;
  var headingText = config.headingText || '';
  var dispatch = useDispatch();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    service = _useState2[0],
    setService = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    hostedFieldsService = _useState4[0],
    setHostedFieldsService = _useState4[1];
  useEffect(function () {
    if (!service) return;
    var clientInstance = service.clientInstance;
    /* istanbul ignore next */
    if (!hostedFieldsService) {
      var _hostedFieldsService = new HostedFieldsService({
        instance: clientInstance,
        dispatch: dispatch,
        rioNamespace: rioNamespace
      });
      setHostedFieldsService(_hostedFieldsService);
    }
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.PM_LOADED'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
  }, [service]);

  // triggered when the BraintreeService.clientInstance is done initializing
  var _callback = function callback(braintreeService) {
    doBraintreeCallback(braintreeService, setService);
  };
  var _dataCollectorCallback = function dataCollectorCallback(deviceData) {
    dispatch(updateDeviceData(deviceData));
  };
  var renderPaymentViews = function renderPaymentViews() {
    return /*#__PURE__*/React.createElement(PaymentViews, {
      mode: mode,
      priceSummary: priceSummary,
      showHeading: showHeading,
      headingText: headingText,
      initialHeadingLevel: initialHeadingLevel,
      hostedFieldsService: hostedFieldsService,
      braintreeService: service,
      yifteeBalance: yifteeBalance,
      optimizelyClient: optimizelyClient
    });
  };
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(LoadingIndicator, null)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, isBraintreeEnabled && /*#__PURE__*/React.createElement(Braintree, {
    callback: function callback(braintreeService) {
      return _callback(braintreeService);
    },
    dataCollectorCallback: function dataCollectorCallback(deviceData) {
      return _dataCollectorCallback(deviceData);
    }
  }), renderPaymentViews()));
};
export default /*#__PURE__*/React.memo(InitializeBraintree);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/InitializeBraintree/index.js
// module id = 4535
// module chunks = 11